import { createFileRoute } from '@tanstack/react-router'

import { requireFeatureFlag } from 'lib/routeGuards'

import NewChallenge from 'pages/NewChallenge'

export const Route = createFileRoute('/_auth/challenges/new')({
  beforeLoad: requireFeatureFlag('challenges'),
  component: NewChallenge,
})
